export enum StatusHorario {
    PENDENTE = 'pendente',
    AGENDADO = 'agendado',
    CANCELADO = 'cancelado',
    CONCLUIDO = 'concluído',
}

export const StatusHorarioLabels: Record<StatusHorario, string> = {
    [StatusHorario.PENDENTE]: 'Pendente',
    [StatusHorario.AGENDADO]: 'Agendado',
    [StatusHorario.CANCELADO]: 'Cancelado',
    [StatusHorario.CONCLUIDO]: 'Concluído',
};

interface TimeSlot {
    start: number;
    end: number;
}

export interface Horarios {
    [key: string]: TimeSlot[];
}

export const dayLabels: { [key: string]: string } = {
    segunda: 'Segunda-feira',
    terca: 'Terça-feira',
    quarta: 'Quarta-feira',
    quinta: 'Quinta-feira',
    sexta: 'Sexta-feira',
    sabado: 'Sábado',
    domingo: 'Domingo',
};

export const minutesToTime = (minutes: number): string => {
    const hours = Math.floor(minutes / 60)
        .toString()
        .padStart(2, '0');
    const mins = (minutes % 60).toString().padStart(2, '0');
    return `${hours}:${mins}`;
};

export const timeToMinutes = (time: string): number => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
};

export const initialHorarios: Horarios = {
    segunda: [],
    terca: [],
    quarta: [],
    quinta: [],
    sexta: [],
    sabado: [],
    domingo: [],
};

export interface Agendamento {
    timezone?: string;
    startMinutes?: number;
    _id: string;
    status: StatusHorario;
    service: {
        _id: string;
        name: string;
        duration?: number;
        imagesIds: string[];
        price: number;
    };
    servicosExtras?: {
        _id: string;
        name: string;
        description?: string;
        duration?: number;
        price: number;
        updatedAt?: Date | string;
    }[];
    totalPrice?: number;
    totalDuration?: number;
    paymentStatus?: string;
    paymentMethod?: string;
    paymentProvider?: string;
    subscriptionLimit?: {
        reached: boolean;
        expectedTotal: number;
    };
    attendant: {
        uid: string;
        name: string;
        email: string;
        phoneNumber: string;
        profilePictureUrl: string;
    };
    assessment?: {
        value: number;
        observation: string;
        date: Date;
    };
    cancellation?: {
        date: string;
        userId: string;
        required: boolean;
        observation: string;
        minutesBeforeCancellation: number
    };
    scheduleDate: string;
    confirmationDate: string;
    observationClient: string;
    startAt: string;
    endAt: string;
    googleEventId?: string;
    googleEventLink?: string;
    estab: {
        _id: string;
        name: string;
        imageId: string;
        description: string;
        address: any;
        phoneNumber: string;
        isPhoneNumberWhatsapp: boolean;
        location: string;
    };
    observation?: string;
    client: {
        uid: string;
        name: string;
        email: string;
        phoneNumber?: string;
        profileImageUrl?: string;
        whatsappLink?: string;
        amountSchedules?: Number;
    };
    accessibility?: {
        observation: string;
    };
    confirmation: {
        date?: Date;
        userId?: string;
        required: boolean;
        minutesBeforeConfirmation: number;
    };
    createdAt: string;
    recorrenciaId?: string;
    recurrence?: RecurrenceInfo | null;
    subscription?: SubscriptionInfo | null;
    saleOpportunity?: SaleOpportunityInfo | null;
    payment?: AppointmentPaymentInfo | null;
}

export interface AppointmentPaymentInfo {
    _id: string;
    status: 'PENDING' | 'PAID' | 'EXPIRED' | 'CANCELED' | 'REFUNDED' | 'FAILED' | string;
    provider: string;
    amount: number;
    currency: string;
    expiresAt?: string | Date;
    paidAt?: string | Date;
    paymentMethod?: string;
    pix?: {
        payload?: string;
        encodedImage?: string;
        expirationDate?: string | Date;
    };
    invoiceUrl?: string;
    transactionReceiptUrl?: string;
}

export interface RecurrenceInfo {
    recorrenciaId?: string;
    tipo?: 'dias' | 'semanas' | 'meses' | string;
    frequencia?: number;
    diaSemana?: string;
    modoMensal?: 'diaMes' | 'diaSemana' | string;
    ocorrenciaMensal?: 'primeira' | 'segunda' | 'terceira' | 'quarta' | 'ultima' | string;
    diaMes?: number;
    startAt?: string | Date;
    endAt?: string | Date;
    assinaturaId?: string;
}

export interface SubscriptionInfo {
    assinaturaId?: string;
    periodoId?: string;
    isPreLinked?: boolean;
    planName?: string;
    billingType?: 'RECORRENTE' | 'UNICO' | string;
    price?: number;
    appointmentDiscountPercent?: number;
    recurrence?: { value?: number; unit?: string } | null;
    duration?: { value?: number; unit?: string } | null;
    period?: {
        inicio?: string | Date;
        fim?: string | Date;
        dueAt?: string | Date;
        cobrancaStatus?: string;
    };
    usage?: {
        serviceId?: string;
        serviceName?: string;
        used?: number;
        limit?: number;
    };
    usages?: Array<{
        serviceId?: string;
        serviceName?: string;
        used?: number;
        limit?: number;
    }>;
    nextBillingAt?: string | Date | null;
    status?: number;
}

export interface SaleOpportunityInfo {
    activeRecurringCount: number;
    totalItems: number;
    estimatedTotal: number;
    frequencies: Array<'SEMANAL' | 'MENSAL' | string>;
}
